import React, { useEffect, useRef } from 'react';

import { ReaderBlock } from '../../Reader/core';

import { FormLayoutPropsDefaults } from './EmailLayoutPropsSchema';
import { Form, Select } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import formClasses from './formclass.module.css'
import styled from 'styled-components';
import { getResponsiveValue } from '../../../../utils/commonFun';

function getFontFamily(fontFamily) {
  const f = fontFamily ?? 'MODERN_SANS';
  switch (f) {
    case 'MODERN_SANS':
      return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
    case 'BOOK_SANS':
      return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
    case 'ORGANIC_SANS':
      return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
    case 'GEOMETRIC_SANS':
      return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
    case 'HEAVY_SANS':
      return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
    case 'ROUNDED_SANS':
      return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
    case 'MODERN_SERIF':
      return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
    case 'BOOK_SERIF':
      return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
    case 'MONOSPACE':
      return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
  }
}

function getBorder({ borderColor }) {
  if (!borderColor) {
    return undefined;
  }
  return `1px solid ${borderColor}`;
}

const getPadding = (padding, isMobile) =>
    padding ? `${getResponsiveValue(padding.top, padding.mobileTop, isMobile) ?? 0}px auto ${getResponsiveValue(padding.bottom, padding.mobileBottom, isMobile) ?? 0}px auto` : undefined;

const StyledForm = styled(Form)`
    overflow: hidden;
    grid-template-columns: 1fr !important;

    > * {
      min-width: 0 !important;
    }

    .ant-form-item {
        margin-bottom: 0;
        min-width: 0;
    }
    .ant-form-item.ant-form-item-label-right .ant-form-item-label {
      text-align: end;
    }
    .ant-select-single {
      height: unset;
    }

    .ant-radio-wrapper {
      margin-inline-end: 0
    }

    .ant-btn {
      height: unset;
    }

    .ant-form-item-control-input-content {
      min-width: 0;
    }
    .ant-form-item-control-input {
      min-width: 0;
    }
    .ant-form-item-control {
      min-width: 0;
    }
    .ant-col.ant-form-item-control {
      min-width: 0;
    }
    .ant-form-item-row {
      min-width: 0;
    }
`;

export default function FormLayoutReader({isEmbed, fCode, cmCode, props, custom_form, handleSubmit, formData, handleAlertError,
  otpLoading,
  canSendOtp,
  waitOtpSeconds,
  validateOtpResult,
  validateOtpLoading,
  handleStartSendOtp,
  handleChangeOTP,
  handleChangeEmail,
  allFieldValues,
  setAllFieldValues,
  formClientWidth,
  setFormClientWidth,
  unSubData,
  errorMessage,
  successMessage,
  languageOptions,
  selectedLanguageCode,
  showLanguageSelector,
  handleChangeLanguage,
  recaptcha
}) {
  const formWrapperRef = useRef(null);
  useEffect(() => {
    const sendHeightToParent = () => {
      const wrapper = formWrapperRef.current;
      if (wrapper && setFormClientWidth) {
        setFormClientWidth(wrapper.clientWidth);
        const height = wrapper.scrollHeight;
        window.parent.postMessage({ type: 'formHeight', height }, '*');
      }
    };

    // 初始 & resize 时触发
    sendHeightToParent();
    window.addEventListener('resize', sendHeightToParent);

    // 监听 DOM 变化
    const observer = new MutationObserver(sendHeightToParent);
    if (formWrapperRef.current) {
      observer.observe(formWrapperRef.current, { childList: true, subtree: true });
    }

    // 清理
    return () => {
      window.removeEventListener('resize', sendHeightToParent);
      observer.disconnect();
    };
  }, []);

  const childrenIds = props.childrenIds ?? [];
  var _f;
  var e_props = props.props;
  var visible = (_f = e_props === null || e_props === void 0 ? void 0 : e_props.visible) !== null && _f !== void 0 ? _f : FormLayoutPropsDefaults.visible;
  var flexBlock = props.alignCenter ? {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
  } : {}
  const isMobileViewport = formClientWidth <= 480 || (typeof window !== 'undefined' && window.matchMedia('(max-width: 480px)').matches);
  const config_padding = {
    top: props.padding?.top ?? 32,
    bottom: props.padding?.bottom ?? 32,
  }
  const padding = getPadding(config_padding, isMobileViewport)
  return (
    !visible ? null : <div ref={formWrapperRef}
      style={{
        backgroundColor: props.backdropColor ?? '#F5F5F5',
        color: props.textColor ?? '#262626',
        fontFamily: getFontFamily(props.fontFamily),
        fontSize: '16px',
        transform: formClientWidth <= 480 ? "scale(0.98)" : "scale(1)",
        transformOrigin: "center top",
        fontWeight: '400',
        letterSpacing: '0.15008px',
        lineHeight: '1.5',
        margin: '0',
        // padding: isEmbed ? '16px 0' : formClientWidth <= 480 ? '16px 0 80px 0' : '32px 0 100px 0',
        // height: isEmbed ? 'unset' : `calc(100vh - ${formClientWidth <= 480 ? '80px - 16px' : '100px - 32px'})`,
        padding: padding,
        minHeight: isEmbed ? 'unset': `calc(100vh - ${config_padding.top + config_padding.bottom}px - 107px)`,
        width: '100%',
        ...flexBlock
      }}
    >
      <div
        style={{
          width: flexBlock ? 'unset' : "100%",
          margin: '0 auto',
          maxWidth: '1024px',
          backgroundColor: props.canvasColor ?? '#FFFFFF',
          borderRadius: props.borderRadius ?? undefined,
          border: getBorder(props),
        }}
      >
        {
          showLanguageSelector && languageOptions?.length > 1 && !isEmbed ? <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            gap: '8px',
            padding: '16px 24px 0 24px'
          }}>
            <span style={{whiteSpace: 'nowrap'}}>
              <GlobalOutlined /> Language:
            </span>
            <Select
              value={selectedLanguageCode || undefined}
              options={languageOptions}
              style={{ minWidth: '180px' }}
              onChange={handleChangeLanguage}
            />
          </div> : null
        }
        <StyledForm
          layout={props?.formStyle?.layout || FormLayoutPropsDefaults?.formStyle?.layout} 
          size={props?.formStyle?.size || FormLayoutPropsDefaults?.formStyle?.size} 
          variant={props?.formStyle?.border || FormLayoutPropsDefaults?.formStyle?.border} 
          labelAlign={props?.formStyle?.labelAlign || FormLayoutPropsDefaults?.formStyle?.labelAlign} 
          colon={props?.formStyle?.colon} 
          className={formClasses.formRoot}
          form={custom_form}
          onFinish={handleSubmit}
        >
          {childrenIds.map((childId) => (
            <ReaderBlock key={childId} id={childId} fCode={fCode} cmCode={cmCode} formData={formData} formRef={custom_form} handleAlertError={handleAlertError}
              otpLoading={otpLoading}
              canSendOtp={canSendOtp}
              waitOtpSeconds={waitOtpSeconds}
              validateOtpResult={validateOtpResult}
              validateOtpLoading={validateOtpLoading}
              handleStartSendOtp={handleStartSendOtp}
              handleChangeOTP={handleChangeOTP}
              handleChangeEmail={handleChangeEmail}
              allFieldValues={allFieldValues}
              setAllFieldValues={setAllFieldValues}
              formClientWidth={formClientWidth}
              unSubData={unSubData}
              errorMessage={errorMessage}
              successMessage={successMessage}
              recaptcha={recaptcha}
            />
          ))}
        </StyledForm>
      </div>
    </div>
  );
}
